(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-product-comparison';

  function initSection(section) {
    if (!section || section.dataset.odditComparisonInit === 'true') return;
    section.dataset.odditComparisonInit = 'true';

    var scroller = section.querySelector('.oddit-section-product-comparison__scroll');
    var prevBtn = section.querySelector('[data-oddit-comparison-scroll="prev"]');
    var nextBtn = section.querySelector('[data-oddit-comparison-scroll="next"]');

    if (!scroller || (!prevBtn && !nextBtn)) return;

    function updateButtonState() {
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      var scrolled = scroller.scrollLeft;
      if (prevBtn) prevBtn.disabled = scrolled <= 1;
      if (nextBtn) nextBtn.disabled = scrolled >= maxScroll - 1;
    }

    function scrollBy(direction) {
      var amount = Math.max(scroller.clientWidth * 0.7, 200);
      scroller.scrollBy({
        left: direction === 'next' ? amount : -amount,
        behavior: 'smooth'
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { scrollBy('prev'); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { scrollBy('next'); });
    }

    scroller.addEventListener('scroll', function () {
      requestAnimationFrame(updateButtonState);
    });

    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(function () { updateButtonState(); });
      ro.observe(scroller);
      section._odditResizeObserver = ro;
    } else {
      window.addEventListener('resize', updateButtonState);
    }

    updateButtonState();
  }

  function destroySection(section) {
    if (!section) return;
    if (section._odditResizeObserver) {
      section._odditResizeObserver.disconnect();
      section._odditResizeObserver = null;
    }
    delete section.dataset.odditComparisonInit;
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();